import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import "./Fees.css";
import { getTranslatedText as translate } from "../../Localization/Translation";

function Fees() {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));

  return (
    <div className="Fees-Component">
      <form>
        <div className="mb-4 row">
          <label
            htmlFor="exampleInputPassword1"
            className="form-label col-md-9"
          >
            {translate("label-1-fees", locale)}
          </label>
          <div className="col row">
            <input type="password" className="form-control col" id="fee" />
            <span className="col-8">{translate("currency-saudi", locale)}</span>
          </div>
        </div>
        <div className="mb-4 row">
          <label
            htmlFor="exampleInputPassword1"
            className="form-label col-md-9"
          >
            {translate("label-2-fees", locale)}
          </label>
          <div className="col row">
            <input
              type="password"
              className="form-control col"
              id="commission"
            />
            <span className="col-8">{translate("currency-saudi", locale)}</span>
          </div>
        </div>
        <button type="submit" className="btn btn-primary">
          {translate("modal-ok-btn", locale)}
        </button>
      </form>
    </div>
  );
}

export default Fees;
